export const TrustBar = ({ items }) => (
  <div className="trust-bar">
    {items.map((item, i) => (
      <div className="trust-item" key={i}>
        <span className="trust-dot" aria-hidden="true" />
        {item}
      </div>
    ))}
  </div>
);
